<template>
  <div class="settings-local">
    <!-- <section class="mb-8">
      <h3 v-t="'page.account.settings.ui'" class="text-h5 text-uppercase font-weight-extrabold mb-2" />

      <SettingsToggle
        v-model="settings.interface.chat.visible"
        :label="$t('page.account.settings.ui.chat')"
      />
    </section> -->

    <section class="mb-8">
      <h3 v-t="'page.account.settings.audio'" class="text-h5 text-uppercase font-weight-extrabold mb-2" />

      <SettingsSlider
        v-model="settings.sounds.volumes.master"
        :value-label="settings.sounds.volumes.master * 10"
        color="primary500"
        :label="$t('page.account.settings.audio.main')"
        step=".1"
        min="0"
        max="1"
        class="mb-1"
      />

      <!-- <SettingsSlider
        v-model="settings.sounds.volumes.game"
        :value-label="settings.sounds.volumes.game * 10"
        color="primary500"
        :label="$t('page.account.settings.audio.games')"
        step=".1"
        min="0"
        max="1"
        class="mb-2"
      /> -->

      <SettingsSlider
        v-model="settings.sounds.volumes.items"
        :value-label="settings.sounds.volumes.items * 10"
        color="primary500"
        :label="$t('page.account.settings.audio.items')"
        step=".1"
        min="0"
        max="1"
        class="mb-1"
      />

      <SettingsSlider
        v-model="settings.sounds.volumes.notifications"
        :value-label="settings.sounds.volumes.notifications * 10"
        color="primary500"
        :label="$t('page.account.settings.audio.notifications')"
        step=".1"
        min="0"
        max="1"
      />
    </section>

    <!-- TODO localize -->
    <section class="mb-8">
      <h3 class="text-h5 text-uppercase font-weight-extrabold mb-2">
        Tips &amp; tours
      </h3>

      <SettingsToggle
        v-model="settings.onboarding.disabled"
        label="Disable help tours"
        class="mb-2"
      />

      <div class="d-flex align-center mb-2">
        <label v-text="'Reset all tours'" />
        <v-spacer />
        <v-btn
          class="rounded-0 text-body-2"
          :ripple="false" depressed height="32" color="grey500"
          @click="onResetTours"
        >
          <div class="d-flex align-center font-weight-bold text--secondary">
            <span v-t="'Reset tours'" />
          </div>
        </v-btn>
      </div>
    </section>

    <section class="mb-8">
      <h3 v-t="'common.games.wheel'" class="text-h5 text-uppercase font-weight-extrabold mb-2" />

      <SettingsToggle
        v-model="settings.games.wheel.sounds"
        :label="$t('page.account.settings.wheel.sounds')"
        class="mb-2"
      />

      <div class="d-flex align-center mb-2">
        <label v-t="'page.account.settings.wheel.stacks'" />
        <v-spacer />
        <v-btn
          class="rounded-0 text-body-2"
          :ripple="false" depressed height="32" color="grey500"
          @click="$modal.open('wheel-stacks', {maxWidth: 500})"
        >
          <div class="d-flex align-center font-weight-bold primary500--text">
            <fai :icon="['fad', 'external-link']" class="mr-2" />
            <span v-t="'cta.customize'" />
          </div>
        </v-btn>
      </div>

      <SettingsToggle
        v-model="settings.games.wheel.simple"
        :label="$t('page.account.settings.games.wheel.simplified')"
      />
    </section>

    <section>
      <h3 v-t="'common.games.coinflip'" class="text-h5 text-uppercase font-weight-extrabold mb-2" />

      <SettingsToggle
        v-model="settings.games.coinflip.sounds"
        :label="$t('common.sounds')"
        class="mb-2"
      />
    </section>
  </div>
</template>

<script>
import SettingsSlider from './SettingsSlider'
import SettingsToggle from './SettingsToggle'

const deepclone = require('rfdc')()

export default {
  components: { SettingsSlider, SettingsToggle },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    settings: null,
  }),
  watch: {
    value: {
      handler(val) {
        // avoid triggering infinite loop, "deep equal"
        if (JSON.stringify(val) === JSON.stringify(this.settings)) {
          return
        }

        this.settings = deepclone(val)
      },
      immediate: true,
    },
    settings: {
      handler(val, old) {
        if (val && old) {
          this.$emit('input', val)
        }
      },
      deep: true,
    },
  },
  methods: {
    onResetTours() {
      this.settings.onboarding.seen = []
      this.$toast.info('Help tours reset')
    },
  },
}
</script>

<style lang="scss" scoped>
label {
  color: #cecece;
  text-transform: uppercase;
}
</style>
